import { gql } from '@edreamsodigeo/frontend-api-client';

export const USER_INFO_QUERY = gql`
  query userInfoQuery {
    userInfo {
      name
    }
  }
`;
